import { useEffect } from "react";
import { googleLoginService } from "../../services/googleLoginService"; 
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/auth";



const CLIENT_ID = "844013135626-o9l89dbc9qarjvm01oo98t66v96j3ubm.apps.googleusercontent.com";

export default function GoogleLoginButton({ }) {

//   const { setGoogleToken } = useGoogleAuth()
  const { storeGooleAuthToken, getGoogleAuthToken } = useAuth();
//   const { connectWebSocket, setErrorMessage } = useWebSocket()
  const navigate = useNavigate()
  useEffect(() => {
    // Load Google script dynamically (optional if included in HTML)
    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    script.onload = () => {
      /* global google */
      google.accounts.id.initialize({
        client_id: CLIENT_ID,
        callback: handleGoogleResponse,
      });

      google.accounts.id.renderButton(
        document.getElementById("googleSignInDiv"),
        {


          theme: "outline", size: "large"
        }
      );
    };

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const handleGoogleResponse = async (credentialResponse) => {
    try {
      const token = credentialResponse.credential;
      // console.log("Google ID Token:", token);
    //   setGoogleToken(token);
      const result = await googleLoginService(token);










      if (result.success && result.status === 200) {
        console.log("Login successful:", result.user, result.data);

       
        const gtoken = result.data?.data;
        const error = result.data?.error;
        const mailError = result.data?.mail_verification_error;

   
        storeGooleAuthToken(gtoken);

        if (error === false && mailError === false) {
        //   setErrorMessage('');


        //   await connectWebSocket(gtoken);

          // navigate('/dashboard/home');



        } else {
        //   toast.error(result?.data?.data);
        }
      }

      else {
        // toast.error(result?.message);
      }



    }

    catch (err) {
      console.error("Google login error:", err);
    }
  };

  return <div id="googleSignInDiv"></div>;
}
